import { APPOINTMENT_TYPE } from '../constants/appointment-type';

/**
 * @param currentRoute historyService.getCurrentRoute();
 * @returns APPOINTMENT_TYPE | null
 */
export function getAppointmentType(currentRoute: string): APPOINTMENT_TYPE | null {
  switch (true) {
    case hasRoute(APPOINTMENT_TYPE.CONSULTATIONS, currentRoute):
      return APPOINTMENT_TYPE.CONSULTATIONS;
    case hasRoute(APPOINTMENT_TYPE.EXAMS, currentRoute):
      return APPOINTMENT_TYPE.EXAMS;
    case hasRoute(APPOINTMENT_TYPE.SERVICES, currentRoute):
      return APPOINTMENT_TYPE.SERVICES;
    case hasRoute(APPOINTMENT_TYPE.SURGERIES, currentRoute):
      return APPOINTMENT_TYPE.SURGERIES;
    case hasRoute(APPOINTMENT_TYPE.CHEMOTHERAPIES, currentRoute):
      return APPOINTMENT_TYPE.CHEMOTHERAPIES;
    case hasRoute(APPOINTMENT_TYPE.REQUEST, currentRoute):
      return APPOINTMENT_TYPE.REQUEST;
    case hasRoute(APPOINTMENT_TYPE.WAITING_LIST, currentRoute):
      return APPOINTMENT_TYPE.WAITING_LIST;
    default:
      return null;
  }
}

function hasRoute(route: string, currentRoute: string): boolean {
  return currentRoute.includes(route);
}